"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _ = require("../..");
var _react2 = require("@emotion/react");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const Textarea = ({
  label,
  value = '',
  rows = 3,
  resize = 'vertical',
  placeholder,
  maxLength,
  focus,
  invalidMessage,
  maxHeight,
  disabled,
  onChange,
  ...restProps
}) => {
  const theme = (0, _react2.useTheme)();
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const handleChange = e => {
    setInputValue(e.target.value);
    if (onChange) {
      onChange(e.target.value);
    }
  };
  (0, _react.useEffect)(() => {
    setInputValue(value);
  }, [value]);
  const aria = `textarea-${label ? label.replace(' ', '-') : 'primary'}`;
  return (0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    children: [label && (0, _jsxRuntime.jsx)(_styles.Label, {
      htmlFor: aria,
      children: label
    }), (0, _jsxRuntime.jsx)("textarea", {
      id: aria,
      css: theme => [_styles.styles.default(theme), _styles.styles.resize(resize), maxHeight && _styles.styles.maxHeight(maxHeight), disabled && _styles.styles.disabled(theme)],
      "aria-label": label,
      "aria-invalid": !!invalidMessage,
      value: inputValue,
      rows: rows,
      placeholder: placeholder,
      onChange: handleChange,
      maxLength: maxLength,
      autoFocus: focus,
      disabled: disabled,
      ...restProps
    }), invalidMessage && (0, _jsxRuntime.jsxs)(_styles.ErrorMessage, {
      theme: theme,
      children: [(0, _jsxRuntime.jsx)(_.IconErrorOutline, {
        size: "16px"
      }), invalidMessage]
    })]
  });
};
var _default = exports.default = Textarea;